import React from "react";
import PropTypes from "prop-types";
import Message from "./Message";

const Messages = ({ messages, clearMessage }) =>
  messages &&
  messages.length > 0 && (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "relative",
        overflow: "visible",
        zIndex: 9999
      }}
    >
      <div
        className="mb-5"
        style={{
          position: "fixed",
          bottom: "50%",
          right: "50%",
          transform: "translate(50%, 50%)"
        }}
      >
        {messages.map((m, i) => (
          <Message key={i} index={i} message={m} clearMessage={clearMessage} />
        ))}
      </div>
    </div>
  );

Messages.propTypes = {
  messages: PropTypes.array.isRequired,
  clearMessage: PropTypes.func.isRequired
};

export default Messages;
